import { render, staticRenderFns } from "./SearchLabels.vue?vue&type=template&id=05c5f1ed&scoped=true"
import script from "./SearchLabels.vue?vue&type=script&lang=js"
export * from "./SearchLabels.vue?vue&type=script&lang=js"
import style0 from "./SearchLabels.vue?vue&type=style&index=0&id=05c5f1ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c5f1ed",
  null
  
)

export default component.exports